import { useContext } from "react";
import { LaunchableDeploymentContext } from "../deployment/LaunchableDeploymentContext";

export function useLaunchableDeployment() {
  const value = useContext(LaunchableDeploymentContext);
  if (!value) {
    throw new Error(
      "useLaunchableDeployment must be used within LaunchableDeploymentProvider",
    );
  }
  return value;
}
